module.exports = __webpack_public_path__ + "img/maestro.07e00245.svg";